import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4h5v4h3v-2h2v-2h6v4h-2v2h-2v4h2v2h2v4h-6v-2h-2v-2h-3v4h-5l0 -16","key":"svg-0"}]]

const IconBrandKick = createReactComponent('outline', 'brand-kick', 'BrandKick', __iconNode);

export default IconBrandKick;